export const capitaliseFirstLetter = (sentence: string, firstWordOnly = false) => {
  if (firstWordOnly) {
    return sentence.charAt(0).toUpperCase() + sentence.slice(1);
  }

  return sentence
    .split(' ')
    .map(word => word[0].toUpperCase() + word.slice(1))
    .join(' ');
};
